import { FC, PropsWithChildren } from 'react';

import ToggleHelpCalloutButton from '../../_common/components/callout/ToggleHelpCalloutButton';
import useToggle from '../../_common/hooks/useToggle';
import Container from '@carrot-deprecated/container';
import Callout from '@carrot-deprecated/callout';

export const FormFieldExplanation: FC<PropsWithChildren> = ({ children }) => {
  const [show, toggle] = useToggle(false);
  if (!children) {
    return null;
  }

  return (
    <>
      <Container flexGrow={1}>
        <ToggleHelpCalloutButton onToggle={toggle} isToggled={show} />
      </Container>
      {show && (
        <Callout colour="lightGrey" mb="xxs" mt="xxs">
          {children}
        </Callout>
      )}
    </>
  );
};
